import React, { useMemo, useState } from 'react';
import { QUICK_REPLIES, QuickReply } from './QUICK_REPLIES';

interface Props {
  onSelect: (message: string) => void;
  replies?: QuickReply[];
}

export const QuickRepliesPanel: React.FC<Props> = ({ onSelect, replies = [] }) => {
  const [search, setSearch] = useState('');
  const [category, setCategory] = useState('Todos');

  const allReplies = QUICK_REPLIES;
  const suggestedIds = new Set(replies.map(item => item.id));

  const categories = useMemo(
    () => ['Todos', ...Array.from(new Set(allReplies.map(item => item.category)))],
    [allReplies],
  );

  const filteredReplies = useMemo(() => {
    const normalizedSearch = search.toLowerCase().trim();

    const result = allReplies.filter(item => {
      const matchCategory = category === 'Todos' || item.category === category;
      const matchSearch =
        normalizedSearch.length === 0 ||
        item.title.toLowerCase().includes(normalizedSearch) ||
        item.message.toLowerCase().includes(normalizedSearch);

      return matchCategory && matchSearch;
    });

    if (!normalizedSearch && replies.length > 0) {
      return [...result].sort((a, b) => {
        const aSuggested = suggestedIds.has(a.id) ? 1 : 0;
        const bSuggested = suggestedIds.has(b.id) ? 1 : 0;

        return bSuggested - aSuggested;
      });
    }

    return result;
  }, [search, category, allReplies, replies, suggestedIds]);

  return (
    <div className="quick-replies-panel">
      <h6>Respostas rápidas</h6>

      <div className="quick-replies-toolbar">
        <input
          className="quick-replies-search"
          type="text"
          placeholder="Buscar resposta..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />

        <select
          className="quick-replies-select"
          value={category}
          onChange={e => setCategory(e.target.value)}
        >
          {categories.map(item => (
            <option key={item} value={item}>
              {item}
            </option>
          ))}
        </select>
      </div>

      <div className="quick-replies-list">
        {filteredReplies.map(reply => (
          <button
            key={reply.id}
            type="button"
            className="quick-reply-item"
            onClick={() => onSelect(reply.message)}
          >
            <strong>{reply.title}</strong>
            <span>{reply.category}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
